// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___98d67c1a32acf6a527f","cls2":"CreateSocialItemModal-cls2__c9ac26c18f1e17fe39c7 CreateSocialItemModal-cls1___98d67c1a32acf6a527f"};